import dayjs from "dayjs";

import { Data } from "./types";

import { IInstitutionDevice } from "@/api/types/institution";

export function createData(data: IInstitutionDevice): Data {
    const { id, deviceUid, deviceName, status, lastSeenAt, createdAt } = data;

    return {
        id,
        deviceUid: deviceUid || "-",
        deviceName: deviceName || "-",
        status,
        lastSeenAt: lastSeenAt ? dayjs(lastSeenAt).format("YYYY-MM-DD HH:mm") : "-",
        createdAt: dayjs(createdAt).format("YYYY-MM-DD HH:mm"),
    };
}
